// Shared Framer Motion variants & transition constants
// Used by all animated components for consistency

export const pageTransition = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
  transition: { duration: 0.15, ease: 'easeOut' },
};

export const staggerContainer = {
  animate: { transition: { staggerChildren: 0.05 } },
};

export const staggerChild = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2, ease: 'easeOut' } },
};

export const modalOverlay = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.15 },
};

export const modalContent = {
  initial: { opacity: 0, scale: 0.95, y: 10 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.95, y: 10 },
  transition: { duration: 0.15, ease: 'easeOut' },
};

export const spring = { type: 'spring', stiffness: 120, damping: 20 };
export const springSnappy = { type: 'spring', stiffness: 300, damping: 25 };

export const buttonTap = { scale: 0.97 };
export const buttonHover = { scale: 1.02 };

export const notificationEnter = {
  initial: { opacity: 0, x: 100, scale: 0.95 },
  animate: { opacity: 1, x: 0, scale: 1 },
  exit: { opacity: 0, x: 100, scale: 0.95 },
  transition: { type: 'spring', stiffness: 300, damping: 25 },
};

export const cashFlyUp = {
  initial: { opacity: 1, y: 0 },
  animate: { opacity: 0, y: -40 },
  transition: { duration: 1.2, ease: 'easeOut' },
};
